var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyaccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 100,
    viewBox: "0 0 75 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_669",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f64c4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(8.972 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.97, -6)",
    filter: "url(#Ellipse_669)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_669-2",
    "data-name": "Ellipse 669",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(11.431 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32256",
    "data-name": "Path 32256",
    d: "M43.478,43.194a7.637,7.637,0,0,1-1.188-.509L41.1,41.539a.478.478,0,0,1,.025-.223l1.041-.38a1.6,1.6,0,0,0,.827-2.372l-.4-.712a4.682,4.682,0,0,0,.08-.864,3.864,3.864,0,0,0-3.572-4.1,3.864,3.864,0,0,0-3.571,4.1,4.686,4.686,0,0,0,.079.864l-.4.712a1.6,1.6,0,0,0,.827,2.372l1.049.384a.477.477,0,0,1,.024.22l-1.188,1.146a7.675,7.675,0,0,1-1.188.509,10.266,10.266,0,0,0-2.866,1.5,8.776,8.776,0,0,0,14.471,0A10.268,10.268,0,0,0,43.478,43.194Z",
    transform: "translate(-21.142 -21.755)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32257",
    "data-name": "Path 32257",
    d: "M6.469,26.8l2.709.454a14.493,14.493,0,0,0,1,2.423l-1.568,2.2a1.67,1.67,0,0,0,.11,2.252l3.07,3.07a1.677,1.677,0,0,0,1.188.495,1.635,1.635,0,0,0,1.031-.359l2.235-1.595a14.21,14.21,0,0,0,2.425,1.006l.444,2.67a1.679,1.679,0,0,0,1.673,1.51h4.341A1.658,1.658,0,0,0,26.8,39.455l.454-2.708a14.135,14.135,0,0,0,2.423-1.006l2.2,1.57a1.665,1.665,0,0,0,1.057.367,1.686,1.686,0,0,0,1.194-.48l3.07-3.07a1.662,1.662,0,0,0,.141-2.219l-1.6-2.233a14.311,14.311,0,0,0,1-2.426l2.667-.451a1.664,1.664,0,0,0,1.518-1.667V20.792a1.664,1.664,0,0,0-1.473-1.667l-2.711-.454a14.249,14.249,0,0,0-1-2.422l1.573-2.2a1.675,1.675,0,0,0-.115-2.25L34.126,8.726a1.654,1.654,0,0,0-1.186-.491,1.629,1.629,0,0,0-1.031.354l-2.237,1.6A14.313,14.313,0,0,0,27.25,9.179L26.8,6.51A1.677,1.677,0,0,0,25.129,5H20.788a1.663,1.663,0,0,0-1.665,1.472l-.451,2.707a14.232,14.232,0,0,0-2.425,1.006l-2.2-1.575a1.668,1.668,0,0,0-1.054-.364,1.685,1.685,0,0,0-1.194.48L8.723,11.8a1.659,1.659,0,0,0-.139,2.221l1.6,2.234a14.377,14.377,0,0,0-1,2.422l-2.67.447a1.677,1.677,0,0,0-1.513,1.674v4.342A1.659,1.659,0,0,0,6.469,26.8ZM22.958,12.583a10.379,10.379,0,1,1-10.38,10.379A10.391,10.391,0,0,1,22.958,12.583Z",
    transform: "translate(-4.995 -5)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyaccount);
export default __webpack_public_path__ + "static/media/myaccount.2d3c0f55d941e510790fa505b4507159.svg";
export { ForwardRef as ReactComponent };